import React, { useContext, useEffect, useState } from 'react'
import { Row, Col, Card } from 'react-bootstrap'
import { PieChart, Pie, Cell, Legend, Tooltip } from "recharts";
import { useNavigate, useParams } from 'react-router-dom'
import { UserContext } from '../../context/UserContextProvider'
import APIServicenew from '../../utils/APIGeneralService'
import useMenuPermissions from '../../components/CustomHook/custompermission'

const Dashboard = () => {

   const [channelStatistics, setchannelStatistics] = useState([]);
   const [topCount, setTopCount] = useState({});
   const [product, setproduct] = useState([]);

   const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
   const authToken = process.env.REACT_APP_authToken;
   const { accessToken, logout } = useContext(UserContext);
   const headers = { "auth-token": authToken, authorization: accessToken };
   const permissionscontext = useMenuPermissions("/admin/dashboard");
   const navigate = useNavigate();


   useEffect(() => {
      fetchDashboardData();
   }, []);

   const fetchDashboardData = async () => {
      try {
         const response = await APIServices.get(
            `admin/dashboard/counts/`,
            headers
         );
         if (response?.status === 200) {
            setTopCount(response?.data?.topCount || {});
            let channelData = response?.data?.channelStatistics;
            let channel = channelData.map(item => ({
               name: item.name,
               value: item.value,
               color: item.color
            }));
            setchannelStatistics(channel || []);

            let productData = response?.data?.product;
            let bardata = transformData(productData);
            setproduct(bardata || []);

         } else if (response?.status === 401) {
            logout();
            navigate("/");
         } else {
            setTopCount({});
            setchannelStatistics({});
         }
      } catch (error) {
         setTopCount({});
         setchannelStatistics({});
      }
   };
   const data = [
      { name: "Completed MoM", value: topCount?.completedMom ? topCount?.completedMom : 0, color: "#3CB371" }, // Green
      { name: "Pending MoM", value: topCount?.pendingdMom ? topCount?.pendingdMom : 0, color: "#FFA500" }, // Orange
   ];
   const total = topCount?.completedMom + topCount?.pendingdMom;

   const data1 = [
      { name: "Banks", value: 151, color: "#4363d8" }, // Blue
      { name: "Wealth Managers", value: 68, color: "#6ABF4B" }, // Green
      { name: "Independent Financial Advisors (IFA)", value: 112, color: "#FFA54D" }, // Orange
   ];

   const total1 = data.reduce((acc, item) => acc + item.value, 0);
  
   const transformData = (data) => {
      // Calculate the total sum of 'value' to calculate the percentage
      const totalValue = data.reduce((sum, product) => sum + parseInt(product.value), 0);

      // Now map the data into the required format for `bardata`
      return data.map((product) => ({
         name: product.name,
         value: parseInt(product.value),
         width: totalValue ? `${(parseInt(product.value) / totalValue) * 100}%` : '0%' // Calculate width as percentage of total value
      }));
   };

   return (
      <>
         <div className='dashboard_inner'>
            <div className="Kpi_row">
               <Row>
                  <Col key='1' xs={12} sm={12} md={6} lg={6} xl={3}>
                     <Card className="d-flex align-items-center text-center">
                        <Card.Header>
                           <img src='/images/Checklist.svg' className="img-fluid" alt="To Do List" />
                        </Card.Header>
                        <Card.Body>
                           <h2 className="font_blue_20 font-600">{topCount?.toDoCounts ? topCount?.toDoCounts : 0}</h2>
                           <p className="font_blue_14">To Do List</p>
                        </Card.Body>
                     </Card>
                  </Col>
                  <Col key='2' xs={12} sm={12} md={6} lg={6} xl={3}>
                     <Card className="d-flex align-items-center text-center">
                        <Card.Header>
                           <img src='/images/mom.svg' className="img-fluid" alt="To Do List" />
                        </Card.Header>
                        <Card.Body>
                           <h2 className="font_blue_20 font-600">{topCount?.momCounts ? topCount?.momCounts : 0}</h2>
                           <p className="font_blue_14">Total MoM</p>
                        </Card.Body>
                     </Card>
                  </Col>
                  <Col key='3' xs={12} sm={12} md={6} lg={6} xl={3}>
                     <Card className="d-flex align-items-center text-center">
                        <Card.Header>
                           <img src='/images/ChannelPartner.svg' className="img-fluid" alt="To Do List" />
                        </Card.Header>
                        <Card.Body>
                           <h2 className="font_blue_20 font-600">{topCount?.channelPartnerCounts ? topCount?.channelPartnerCounts : 0}</h2>
                           <p className="font_blue_14">Total Channel Partner</p>
                        </Card.Body>
                     </Card>
                  </Col>
                  <Col key='4' xs={12} sm={12} md={6} lg={6} xl={3}>
                     <Card className="d-flex align-items-center text-center">
                        <Card.Header>
                           <img src='/images/rm.svg' className="img-fluid" alt="To Do List" />
                        </Card.Header>
                        <Card.Body>
                           <h2 className="font_blue_20 font-600">{topCount?.relationshipManagersCounts ? topCount?.relationshipManagersCounts : 0}</h2>
                           <p className="font_blue_14">Relationship Managers</p>
                        </Card.Body>
                     </Card>
                  </Col>
               </Row>
            </div>

            <div className='dashboard_graph py-4'>
               <Row>
                  <Col md={12} lg={8}>
                     <div className="summary_mom pb-0">
                        {/* Title */}
                        <h2 className="font_blue_18 font-600 text-start">Summary of Minutes of Meeting </h2>

                        {/* Legend */}
                        <div className="d-flex justify-content-start gap-3 my-2">
                           {data.map((item) => (
                              <div key={item.name} className="d-flex align-items-center">
                                 <span
                                    className="rounded-circle me-2"
                                    style={{
                                       backgroundColor: item.color,
                                       width: "10px",
                                       height: "10px",
                                       display: "inline-block",
                                    }}
                                 ></span>
                                 <span className="font_blue_16 font-500">
                                    {item.name}: {item.value}
                                 </span>
                              </div>
                           ))}
                        </div>

                        {/* Semi-circle Pie Chart */}
                        <div className='position-relative'>
                           <div className="d-flex justify-content-center">
                              <PieChart width={600} height={330}>
                                 <Pie
                                    data={data}
                                    cx="50%"
                                    cy="100%"
                                    startAngle={180}
                                    endAngle={0}
                                    innerRadius={230} // Increased from 70
                                    outerRadius={270} // Increased from 90
                                    paddingAngle={2}
                                    dataKey="value"
                                 >
                                    {data.map((entry, index) => (
                                       <Cell key={`cell-${index}`} fill={entry.color} />
                                    ))}
                                 </Pie>
                              </PieChart>
                           </div>
                           <div className='total_mom'>
                              {/* Total MoM Count */}
                              <div className="fw-bold fs-4">{topCount?.completedMom + topCount?.pendingdMom}</div>
                              <div className="text-muted small">Total MoM</div>
                           </div>
                        </div>
                     </div>
                  </Col>
                  <Col md={12} lg={4}>
                     <div className="channel_statistics ">
                        {/* Title */}
                        <h2 className="font_blue_18 font-600 text-start mb-3">Channel Statistics</h2>
                        <div className='d-flex align-items-center justify-content-center'>
                           {/* Pie Chart */}
                           
                           <PieChart width={300} height={250}>
                              <Pie
                                 data={channelStatistics}
                                 cx="50%"
                                 cy="50%"
                                 outerRadius={80}
                                 label={({ percent }) => `${(percent * 100).toFixed(0)}%`}
                                 dataKey="value"
                              >
                                 {channelStatistics && channelStatistics.length > 0 && 
                                 channelStatistics.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={entry.color} />
                                 ))
                                 }
                              </Pie>
                              <Tooltip />
                           </PieChart>
                        </div>

                        {/* Legend */}
                        <div className="mt-2">
                           {channelStatistics && channelStatistics.length > 0 && channelStatistics.map((item, index) => (
                              <div key={index} className="d-flex align-items-center">
                                 <span
                                    className="rounded-circle me-2"
                                    style={{
                                       backgroundColor: item.color,
                                       width: "10px",
                                       height: "10px",
                                       display: "inline-block",
                                    }}
                                 ></span>
                                 <span className="font_blue_14 ">{item.name}</span>
                                 <span className="ms-auto fw-medium">{item.value}</span>
                              </div>
                           ))}
                        </div>
                     </div>
                  </Col>

                  <Col md={12} lg={12}>
                     <div className="bar_process">
                        {/* Title */}
                        <h2 className="font_blue_18 font-600 text-start mb-3">Products Statistics</h2>

                        {/* Bars */}
                        <div className="bar_process_scroll">
                        <Row>
                           <Col md={5} lg={5} xxl={3} >
                              <ul className='nav flex-column'>
                                 {product.map((item, index) => (
                                    <li>
                                       <span className="font_blue_14 textTransform">{item.name}</span>
                                    </li>
                                 ))}
                              </ul>
                           </Col>
                           <Col md={7} lg={7} xxl={9}>
                              <div className="border-start products_bar">
                                 {product.map((item, index) => (
                                    <div key={index} className="mb-3">
                                       {/* Label */}
                                       <div className="d-flex justify-content-end">

                                          <span className="font_blue_12 mb-2">{item.value} MoM</span>
                                       </div>

                                       {/* Progress Bar */}
                                       <div className="progress" style={{ height: "12px", background: "#E5EAF3" }}>
                                          <div
                                             className="progress-bar"
                                             role="progressbar"
                                             style={{
                                                width: item.width,
                                                backgroundColor: "#4363d8",
                                                borderRadius: "10px",
                                             }}
                                          ></div>
                                       </div>
                                    </div>
                                 ))}
                              </div>
                           </Col>
                        </Row>
                        </div>

                     </div>
                  </Col>
               </Row>
            </div>

         </div>
      </>
   )
}

export default Dashboard